import React from 'react';
import classnames from 'classnames';
import SvgIcon from '@/pages/home/components/SvgIcon';
import type { IMixedTypeIconProps } from './types';
import './index.scss';

/**
 * 按来源渲染不同类型 icon：优先 svgIconType（SvgIcon），否则图片 URL。
 */
const MixedTypeIcon: React.FC<IMixedTypeIconProps> = ({
  icon,
  svgIconType,
  rawText = '',
  imgInvert = [],
  className,
}) => {
  const iconClassName = classnames('dbh-mixed-type-icon', className);
  // 调用方可能显式传 null；默认参数仅对 undefined 生效
  const invertWhitelist = Array.isArray(imgInvert) ? imgInvert : [];

  if (svgIconType) {
    return <SvgIcon type={svgIconType} className={iconClassName} />;
  }

  if (icon) {
    return (
      <img
        className={classnames(iconClassName, {
          'db-invert-unset': invertWhitelist.includes(rawText),
        })}
        src={icon}
        alt=""
      />
    );
  }

  return null;
};

export default MixedTypeIcon;
